import { Injectable } from '@angular/core';
import { LeanNetworkService } from 'src/app/tools/services/lean-network-service';
import { UserService } from 'src/app/assabil-kernel/services/user-service';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { PackingOrder } from '../models/entities/packing-order';
import { PackingOrderRequest } from '../models/dto/packing-order-request';
import { PackingOrderStep } from '../models/entities/packing-order-step';
import { PackPackingOrderStep } from '../models/entities/pack-packing-order-step';
import { PackingOrderProductPack } from '../models/entities/packing-order-product-pack';
import { Batch } from 'src/app/assabil-kernel/models/entities/master-data/batch';



@Injectable({
  providedIn: 'root'
})
export class PackingOrderService {

  constructor(private networkService: LeanNetworkService,  public userService : UserService) { }


  //-----------------------------------------------------------------------------------------------------
  packingOrdersGet(
    branchId       : number,
    productId      : number,
    startDate      : Date, 
    endDate        : Date,
    includeOpened  : boolean,
    includeClosed  : boolean)  : Promise<PackingOrder[]> {
    let request     : BaseRequest = new BaseRequest(this.userService.userInfo);

    request.lngArg1   = branchId;
    request.lngArg2   = productId;
    request.dteArg1   = startDate;
    request.dteArg2   = endDate;
    request.blnArg1   = includeOpened;
    request.blnArg2   = includeClosed;
    
    return new Promise((resolve, reject) => {
        this.networkService.post('packing/packingOrdersGet', request).then(result => {
          return resolve(result.packingOrders);
        }, error => {
            reject(error);
        });
    });
  }
  //-----------------------------------------------------------------------------------------------------


  //-----------------------------------------------------------------------------------------------------
  packingOrderGet(packingOrderId : number)  : Promise<PackingOrder> {
    let request    : BaseRequest = new BaseRequest(this.userService.userInfo);
    request.id   = packingOrderId;

    return new Promise((resolve, reject) => {
      this.networkService.post('packing/packingOrderGet', request).then(result => {
          return resolve(result.packingOrder);
        }, error => {
            reject(error);
        });
    });
  }
  //-----------------------------------------------------------------------------------------------------


  //-----------------------------------------------------------------------------------------------------
  packingOrderSave(packingOrder : PackingOrder) : Promise<PackingOrder> {
    let request           : PackingOrderRequest = new PackingOrderRequest(this.userService.userInfo);
    
    request.packingOrder = packingOrder;

    return new Promise((resolve, reject) => {
      this.networkService.post('packing/packingOrderSave', request).then(result => {
          let packingOrder : PackingOrder = result.packingOrder;
          return resolve(packingOrder);
        });
    });
  }
  //-----------------------------------------------------------------------------------------------------



  //-----------------------------------------------------------------------------------------------------
    movePackToPackingOrderStep(packingOrderStep : PackingOrderStep, packCoode : string, packingMachineTypePipeId : number)  : Promise<number> {
      let request    : BaseRequest = new BaseRequest(this.userService.userInfo);
      request.id      = packingOrderStep.id;
      request.code    = packCoode;
      request.lngArg1 = packingMachineTypePipeId;
  
      return new Promise((resolve, reject) => {
        this.networkService.post('packing/movePackToPackingOrderStep', request).then(result => {
            return resolve(result.nbrArg1);
          }, error => {
              reject(error);
          });
      });
    }
    //-----------------------------------------------------------------------------------------------------
  
    //-----------------------------------------------------------------------------------------------------
    addPackToPackingOrderProduct(packingOrderProductId : number, packCoode : string, quantity : number)  : Promise<PackingOrderProductPack> {
      let request    : BaseRequest = new BaseRequest(this.userService.userInfo);
      request.id      = packingOrderProductId;
      request.code    = packCoode;
      request.nbrArg1 = quantity;
  
      return new Promise((resolve, reject) => {
        this.networkService.post('packing/addPackToPackingOrderProduct', request).then(result => {
            return resolve(result.packingOrderProductPack);
          }, error => {
              reject(error);
          });
      });
    }
    //-----------------------------------------------------------------------------------------------------
  
    
    //-----------------------------------------------------------------------------------------------------
    packPackingOrderStepsGet(packCoode : string)  : Promise<PackPackingOrderStep[]> {
      let request    : BaseRequest = new BaseRequest(this.userService.userInfo);
      request.code = packCoode;
  
      return new Promise((resolve, reject) => {
        this.networkService.post('packing/packPackingOrderStepsGet', request).then(result => {
            return resolve(result.packPackingOrderSteps);
          }, error => {
              reject(error);
          });
      });
    }
    //-----------------------------------------------------------------------------------------------------
    
  

   //-----------------------------------------------------------------------------------------------------
   packingOrderPotentialBatchsGet(packingOrder : PackingOrder)  : Promise<Batch[]> {
      let request    : BaseRequest = new BaseRequest(this.userService.userInfo);
      request.id = packingOrder.id;

      return new Promise((resolve, reject) => {
        this.networkService.post('packing/packingOrderPotentialBatchsGet', request).then(result => {
            return resolve(result.batchs);
          }, error => {
              reject(error);
          });
      });
    }


   //-----------------------------------------------------------------------------------------------------
   linkBatchsToPackingOrder(packingOrder : PackingOrder, batchs :Batch[])  : Promise<PackingOrder> {

      let batchIds : number[] = [];      
      for (let batch of batchs){
        batchIds.push(batch.id);
      }

      let request    : BaseRequest = new BaseRequest(this.userService.userInfo);
      request.id = packingOrder.id;
      request.longs = batchIds;
  
      return new Promise((resolve, reject) => {
        this.networkService.post('packing/linkBatchsToPackingOrder', request).then(result => {
            return resolve(result.packingOrder);
          }, error => {
              reject(error);
          });
      });
    }


   //-----------------------------------------------------------------------------------------------------
   packingOrderStart(packingOrder : PackingOrder)  : Promise<PackingOrder> {
    let request    : BaseRequest = new BaseRequest(this.userService.userInfo);
    request.id = packingOrder.id;

    return new Promise((resolve, reject) => {
      this.networkService.post('packing/packingOrderStart', request).then(result => {
          return resolve(result.packingOrder);
        }, error => {
            reject(error);
        });
    });
  }

  
   //-----------------------------------------------------------------------------------------------------
   packingOrderClose(packingOrder : PackingOrder)  : Promise<PackingOrder> {
    let request    : BaseRequest = new BaseRequest(this.userService.userInfo);
    request.id = packingOrder.id;

    return new Promise((resolve, reject) => {
      this.networkService.post('packing/packingOrderClose', request).then(result => {
          return resolve(result.packingOrder);
        }, error => {
            reject(error);
        });
    });
  }
}


